<template>
  <ValidationProvider v-slot="{ errors }" :rules="rules">
    <label
      v-if="label"
      :for="id"
      :class="{ required: rules.includes('required') }"
      v-text="label"
    />
    <textarea
      v-if="type === 'textarea'"
      :id="id"
      :value="value"
      class="form-control rounded-0"
      :name="name"
      :class="{ 'is-invalid': errors.length > 0 }"
      :placeholder="placeholder"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
    />
    <select
      v-else-if="type === 'select'"
      :id="id"
      :value="value"
      class="custom-select"
      :name="name"
      :class="{ 'is-invalid': errors.length > 0, filled: value !== null }"
      :placeholder="name"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
    >
      <slot />
    </select>
    <input
      v-else
      :id="id"
      :value="value"
      :type="type"
      class="form-control"
      :name="name"
      :class="{ 'is-invalid': errors.length > 0 }"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    />
    <span class="invalid-feedback">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        // eslint-disable-next-line
        return `vue-input-${this._uid}`;
      }
    },
    rules: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: [String, Object],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    }
  }
}
</script>
